export default __webpack_public_path__ + "static/media/allinfra4.88a80320.png";